module.exports = __webpack_public_path__ + "static/item1_bg.1dc4080c.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/item1_bg.png
// module id = 1047
// module chunks = 2